
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Textarea } from '@/components/ui/textarea';
import { TabComponentProps } from './types';

const SeoTab: React.FC<TabComponentProps> = ({ metadata, handleInputChange }) => {
  return (
    <div className="space-y-4 p-4">
      <div className="space-y-2">
        <Label htmlFor="seo-title">SEO Title</Label>
        <Input
          id="seo-title"
          placeholder="Title for search engines"
          value={metadata.seoTitle || ''}
          onChange={(e) => handleInputChange('seoTitle', e.target.value)}
        />
        <p className="text-xs text-muted-foreground">
          Recommended length: 50-60 characters
          {metadata.seoTitle === metadata.title && (
            <span className="ml-2 italic">Auto-filled from article title</span>
          )}
        </p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="seo-description">SEO Description</Label>
        <Textarea
          id="seo-description"
          placeholder="Description for search engines"
          className="resize-none"
          rows={3}
          value={metadata.seoDescription || ''}
          onChange={(e) => handleInputChange('seoDescription', e.target.value)}
        />
        <p className="text-xs text-muted-foreground">
          Recommended length: 150-160 characters
          {metadata.seoDescription && metadata.seoDescription.length > 0 && !(metadata.seoTitle === metadata.title) && (
            <span className="ml-2 italic">Auto-filled from first paragraph</span>
          )}
        </p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="canonical-url">Canonical URL (optional)</Label>
        <Input
          id="canonical-url"
          placeholder="https://example.com/original-article"
          value={metadata.canonicalUrl || ''}
          onChange={(e) => handleInputChange('canonicalUrl', e.target.value)}
        />
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="no-index">Hide from search engines</Label>
          <Switch 
            id="no-index" 
            checked={metadata.noIndex || false}
            onCheckedChange={(checked) => handleInputChange('noIndex', checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default SeoTab;
